import { SvgCheck, SvgGuarantee } from "../icons";
import styles from "./membershipInclusion.module.scss";

const MembershipInclusion = () => {
  return (
    <div className={styles.listWrapper}>
      <ul className={styles.list}>
        <li>
          <SvgCheck /> Weekly member's only videos covering TRT/AAS, cutting
          edge health strategies, & more
        </li>
        <li>
          <SvgCheck /> Ask The Doc Live Q&A Meetings
        </li>
        <li>
          <SvgCheck /> ABCD'S™ Interactive Health Diagnostic Tool
        </li>
        <li>
          <SvgCheck /> Private Testosteronology™ Forum
        </li>
        <li>
          <SvgCheck /> Ask Dr. O'Connor GPT
        </li>
        <li>
          <SvgCheck /> Executive History & Physical
        </li>
        <li>
          <SvgCheck /> Personalized Health To-Do List
        </li>
      </ul>
      <span className={styles.guarantee}>
        <SvgGuarantee />
        Our Guarantee
      </span>
      <p className={styles.text}>
        15 day money back guarantee if you sign up on this page. If you are
        unsatisfied in your first two weeks, just email support from inside your
        account requesting a refund.
      </p>

      <p className={styles.text}>
        To read more about feature
        <a
          className={styles.link}
          href="https://www.testosteronology.com"
          target="_blank"
        >
          click here
        </a>
      </p>
    </div>
  );
};

export default MembershipInclusion;
